import { createFileRoute } from '@tanstack/react-router'
import { SendCodeForm } from '@/features/send-code-form'

export const Route = createFileRoute('/_login/login/forgot-password/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <SendCodeForm />
}
